export const Positions = ({ positions }: { positions: string[] }) => {
  return (
    <div className="desktop:m-auto mx-auto flex gap-x-1 md-sm:gap-x-2">
      {positions.map((p) => (
        <div key={p}>{p}</div>
      ))}
    </div>
  );
};
